import React, { useState } from 'react';
import { List, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { CheckMarkSvg } from '@assets';
import { IAmenities } from '@common-types';
import { getAmenityImage } from '@utils';

import './style.scss';

interface IProps {
  amenities: IAmenities[];
  matches?: boolean;
}

const ZERO = 0;
const MAX_AMENITIES_COUNT = 10;

export function AmenityComponent({ amenities, matches }: IProps) {
  const [isFullAmenities, setIsFullAmenities] = useState(false);

  const toggleAmenities = (): void => {
    setIsFullAmenities(!isFullAmenities);
  };

  const resultAmenities = (): React.ReactNode => {
    if (!amenities.length) {
      return;
    }

    const amenitiesToShow: IAmenities[] = isFullAmenities
      ? amenities
      : amenities.slice(ZERO, MAX_AMENITIES_COUNT);

    return (
      <div className="amenities-list">
        <List
          header={amenities[ZERO].categoryName ? <div>{amenities[ZERO].categoryName}</div> : null}
          bordered={false}
          dataSource={
            !matches && amenities.length > MAX_AMENITIES_COUNT ? amenitiesToShow : amenities
          }
          renderItem={(item) => {
            const amenity = getAmenityImage(item);
            return (
            <List.Item>
              {amenity?.image ? <img src={amenity.image} alt="" width="30" height="30" style={amenity.isSVG ? { padding: '5px' } : {}} /> : <CheckMarkSvg />} <Tooltip title={item.name}>{item.name}</Tooltip>
            </List.Item>
          )}}
        />
        <div className="amenities-list__show-link" onClick={toggleAmenities}>
          {!matches &&
            amenities.length > MAX_AMENITIES_COUNT &&
            (isFullAmenities ? (
              <FormattedMessage id="show.less" />
            ) : (
              <FormattedMessage id="show.more" />
            ))}
        </div>
      </div>
    );
  };

  return <div className="amenity">{resultAmenities()}</div>;
}
